import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TicketIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M3.72 14.02C4.84 14 5.76 13.08 5.76 11.96C5.76 10.84 4.84 9.92 3.72 9.9V5.38H20.28V9.9C19.16 9.92 18.24 10.84 18.24 11.96C18.24 13.08 19.16 14 20.28 14.02V18.54H3.72V14.02ZM5.56 16.9H18.44V15C17.32 14.44 16.54 13.32 16.54 11.94C16.54 10.56 17.32 9.46 18.44 8.88V7.02H5.56V8.88C6.68 9.46 7.46 10.56 7.46 11.94C7.46 13.32 6.68 14.44 5.56 15V16.9ZM9.84 9.74C9.3 9.74 8.82 9.3 8.82 8.72C8.82 8.14 9.3 7.7 9.84 7.7C10.4 7.7 10.86 8.14 10.86 8.72C10.86 9.3 10.4 9.74 9.84 9.74ZM9.84 12.98C9.3 12.98 8.82 12.54 8.82 11.96C8.82 11.38 9.3 10.94 9.84 10.94C10.4 10.94 10.86 11.38 10.86 11.96C10.86 12.54 10.4 12.98 9.84 12.98ZM9.84 16.22C9.3 16.22 8.82 15.78 8.82 15.2C8.82 14.62 9.3 14.18 9.84 14.18C10.4 14.18 10.86 14.62 10.86 15.2C10.86 15.78 10.4 16.22 9.84 16.22Z" />
    </SvgIcon>
  );
});
